import React from 'react';
const yonexLogo = 'https://cdn.magicpatterns.com/uploads/oNCPabk56GwxKQ4kyG6cLS/logo-yonex-scaled.webp';
export function SponsorStrip() {
  return <section data-component="COMP-12-SponsorStrip" className="py-12 bg-navy-50 border-y border-navy-100 overflow-hidden" aria-label="Our sponsors and partners" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <p className="text-center text-sm font-bold text-navy-400 uppercase tracking-widest mb-8" data-id="element-255">
          Trusted by leading sports organisations
        </p>
      </div>
      <div className="relative" data-id="element-256">
        <div className="flex animate-scroll-left" data-id="element-257">
          {/* First set */}
          <div className="flex shrink-0 items-center gap-16 px-8" data-id="element-258">
            {Array.from({
            length: 6
          }).map((_, i) => <img key={`a-${i}`} src={yonexLogo} alt="Yonex" className="h-10 md:h-12 w-auto object-contain opacity-70" data-id="element-259" />)}
          </div>
          {/* Duplicate set for seamless loop */}
          <div className="flex shrink-0 items-center gap-16 px-8" data-id="element-260">
            {Array.from({
            length: 6
          }).map((_, i) => <img key={`b-${i}`} src={yonexLogo} alt="Yonex" className="h-10 md:h-12 w-auto object-contain opacity-70" data-id="element-261" />)}
          </div>
        </div>
      </div>
    </section>;
}